import { writable } from "svelte/store";

export const authServer = writable("https://devsharedcms-aim-lts-staff.internal-unilink.co.uk");
export const vptServer = writable("http://localhost:8080");

export const isAuthenticated = writable(false);
export const token = writable("");
export const userUrn = writable(0);
export const userName = writable("");
export const userFilters = writable("");
export const staffUrn = writable("");

export const reportDate = writable();
export const cohortFilters = writable();

export const inmateCount = writable({
    unfiltered: 0, filtered: 0
});

export const showDisclaimer = writable(false);

export const selectedInmate = writable("");
export const selectedInmateDateArrived = writable();
export const selectedInmateDateDeparted = writable();
export const selectedAspect = writable("Overall");
export const inmateDrawerOpen = writable(true);

export const selectedDateRange = writable(0);
export const filterShowTargetedInmatesOnly = writable(false);


export const getTooltipDisplayOptions = (custom) => {
    let defaults = { position: "bottom", align: "center", theme: "tooltip-theme", arrow: false, maxWidth: 300 }
    return { ...defaults, ...custom }
}

export const standardDateRanges = [
    { value : 30, label : 'Last Month'},
    { value : 91, label : 'Last 3 Months'},
    { value : 365, label : 'Last 12 Months'},
    { value : 1095, label : 'Last 3 Years'},
    { value : -3, label : 'Latest Stay'},
    { value : -2, label : 'This Year'},
];